import { render, staticRenderFns } from "./GExamCreateBaseSetting.vue?vue&type=template&id=9d31b8a2&scoped=true&"
import script from "./GExamCreateBaseSetting.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateBaseSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d31b8a2",
  null
  
)

export default component.exports